// import api from './index'
import request from '../../utils/request'
// 登录
export function employeeLogin(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}
// 剩余积分
export function credits(params) {
  return request({
    url: '/api/user/credits',
    method: 'get',
    params
  })
}
// 积分明细
export function creditsLog(params) {
  return request({
    url: '/api/user/creditsLog',
    method: 'get',
    params
  })
}
// 声音模版
export function voiceText(params) {
  return request({
    url: '/api/user/voiceText',
    method: 'get',
    params
  })
}
// 广告位
export function banner(data) {
  return request({
    url: '/api/index/banner',
    method: 'post',
    data
  })
}

// 上传视频
export function uploadVideo(data) {
  return request({
    url: '/api/upload/video',
    method: 'post',
    data
  })
}
// 上传音频
export function uploadVoice(data) {
  return request({
    url: '/api/upload/voice',
    method: 'post',
    data
  })
}

// 数字演员GET/POST/DELETE
export function getVideo(params) {
  return request({
    url: '/api/user/video',
    method: 'get',
    params
  })
}

// 首页公共演员
export function getIndexVideo(params) {
  return request({
    url: '/api/index/video',
    method: 'get',
    params
  })
}



export function postVideo(data) {
  return request({
    url: '/api/user/video',
    method: 'post',
    data
  })
}
export function delVideo(data) {
  return request({
    url: '/api/user/video',
    method: 'delete',
    data
  })
}

// 数字声音GET/POST/DELETE
export function getVoice(params) {
  return request({
    url: '/api/user/voice',
    method: 'get',
    params
  })
}
export function postVoice(data) {
  return request({
    url: '/api/user/voice',
    method: 'post',
    data
  })
}
export function delVoice(data) {
  return request({
    url: '/api/user/voice',
    method: 'delete',
    data
  })
}

// 数字作品GET/POST/DELETE
export function getWorks(params) {
  return request({
    url: '/api/user/works',
    method: 'get',
    params
  })
}
export function postWorks(data) {
  return request({
    url: '/api/user/works',
    method: 'post',
    data
  })
}
export function delWorks(data) {
  return request({
    url: '/api/user/works',
    method: 'delete',
    data
  })
}

// 声音试听GET/POST
export function getAudition(params) {
  return request({
    url: '/api/user/audition',
    method: 'get',
    params
  })
}
export function postAudition(data) {
  return request({
    url: '/api/user/audition',
    method: 'post',
    data
  })
}
export function voiceConfirm(data) {
  return request({
    url: '/api/user/voiceConfirm',
    method: 'post',
    data
  })
}
// 修改密码
export function changePwd(data) {
  return request({
    url: '/api/user/changePwd',
    method: 'post',
    data
  })
}
// 使用兑换码
export function cdkey(data) {
  return request({
    url: '/api/user/cdkey',
    method: 'post',
    data
  })
}
// 用户剩余空间
export function space(data) {
  return request({
    url: '/api/user/space',
    method: 'post',
    data
  })
}
// 音量音色语调修改
export function voiceEdit(data) {
  return request({
    url: '/api/user/voiceEdit',
    method: 'post',
    data
  })
}

// 站点配置
export function site(params) {
  return request({
    url: '/api/index/site',
    method: 'get',
    params
  })
}

// 直传签名
export function uploadSign(params) {
  return request({
    url: '/api/upload/sign',
    method: 'get',
    params
  })
}
// 公告
export function notice(params) {
  return request({
    url: '/api/index/notice',
    method: 'get',
    params
  })
}
// 上传完成回调
export function uploadComplete(data) {
  return request({
    url: '/api/upload/complete',
    method: 'post',
    data,
    isCheck: 2
  })
}
// 测试
export function timeout(data) {
  return request({
    url: '/index/index/timeout',
    method: 'post',
    data
  })
}

// AI文案主题
export function gtheme(params) {
  return request({
    url: '/api/index/theme',
    method: 'get',
    params
  })
}

// 生成文案
export function postchat(data) {
  return request({
    url: '/api/user/chat',
    method: 'post',
    data
  })
}

// 文案润色
export function textpolish(data) {
  return request({
    url: '/api/user/textpolish',
    method: 'post',
    data
  })
}


// 使用指南
export function gguide(params) {
  return request({
    url: '/api/index/guide',
    method: 'get',
    params
  })
}

// 存储空间扩容
export function spaceExpand(data) {
  return request({
    url: '/api/user/spaceExpand',
    method: 'post',
    data
  })
}


// 声音训练渠道
export function gvoiceChannel(params) {
  return request({
    url: '/api/index/voiceChannel',
    method: 'get',
    params
  })
}

// 声音训练渠道
export function gVideoChannel(params) {
  return request({
    url: '/api/index/videoChannel',
    method: 'get',
    params
  })
}

// 多场景克隆
export function multiWorks(data) {
  return request({
    url: '/api/user/multiWorks',
    method: 'post',
    data
  })
}


// 积分说明
export function creditsRule(params) {
  return request({
    url: '/api/index/creditsRule',
    method: 'get',
    params,
    isCheck: 2
  })
}


// 照片库GET/POST/DELETE
export function getPhoto(params) {
  return request({
    url: '/api/user/photo',
    method: 'get',
    params
  })
}
export function postPhoto(data) {
  return request({
    url: '/api/user/photo',
    method: 'post',
    data
  })
}
export function delPhoto(data) {
  return request({
    url: '/api/user/photo',
    method: 'delete',
    data
  })
}

// 视频提取GET/POST/DELETE
export function getVideoAnalyse(params) {
  return request({
    url: '/api/user/videoAnalyse',
    method: 'get',
    params
  })
}
export function postVideoAnalyse(data) {
  return request({
    url: '/api/user/videoAnalyse',
    method: 'post',
    data
  })
}
export function delVideoAnalyse(data) {
  return request({
    url: '/api/user/videoAnalyse',
    method: 'delete',
    data
  })
}


// 视频翻译GET/POST/DELETE
export function getVideoTranslate(params) {
  return request({
    url: '/api/user/videoTranslate',
    method: 'get',
    params
  })
}
export function postVideoTranslate(data) {
  return request({
    url: '/api/user/videoTranslate',
    method: 'post',
    data
  })
}
export function delVideoTranslate(data) {
  return request({
    url: '/api/user/videoTranslate',
    method: 'delete',
    data
  })
}



//视频翻译语言列表
export function translateLang(params) {
  return request({
    url: '/api/user/translateLang',
    method: 'get',
    params
  })
}

//视频提取免费次数
export function videoAnalyseFree(params) {
  return request({
    url: '/api/user/videoAnalyseFree',
    method: 'get',
    params
  })
}

// 协议富文本
export function protocol(params) {
  return request({
    url: '/api/index/protocol2',
    method: 'get',
    params,
    isCheck: 2
  })
}
//视频生成-灵感词库
export function videoPrompt(params) {
  return request({
    url: '/api/user/videoPrompt',
    method: 'get',
    params
  })
}
//视频生成-创意推荐
export function videoPromptRecommend(params) {
  return request({
    url: '/api/user/videoPromptRecommend',
    method: 'get',
    params
  })
}

// 视频生成GET/POST/DELETE（可灵）
export function getVideoGenerate(params) {
  return request({
    url: '/api/user/videoGenerate',
    method: 'get',
    params
  })
}
export function postVideoGenerate(data) {
  return request({
    url: '/api/user/videoGenerate',
    method: 'post',
    data
  })
}
export function delVideoGenerate(data) {
  return request({
    url: '/api/user/videoGenerate',
    method: 'delete',
    data
  })
}
// 我的预设GET/POST/DELETE
export function getUserPrompt(params) {
  return request({
    url: '/api/user/userPrompt',
    method: 'get',
    params
  })
}
export function postUserPrompt(data) {
  return request({
    url: '/api/user/userPrompt',
    method: 'post',
    data
  })
}
export function delUserPrompt(data) {
  return request({
    url: '/api/user/userPrompt',
    method: 'delete',
    data
  })
}

// 89国语言
export function gLangList(params) {
  return request({
    url: '/api/index/langList',
    method: 'get',
    params
  })
}

// 图片生成-灵感词库
export function gImagePrompt(params) {
  return request({
    url: '/api/user/imagePrompt',
    method: 'get',
    params
  })
}

// 图片生成GET/POST/DELETE
export function getImageGenerate(params) {
  return request({
    url: '/api/user/imageGenerate',
    method: 'get',
    params
  })
}
export function postImageGenerate(data) {
  return request({
    url: '/api/user/imageGenerate',
    method: 'post',
    data
  })
}
export function delImageGenerate(data) {
  return request({
    url: '/api/user/imageGenerate',
    method: 'delete',
    data
  })
}

//音频提取免费次数
export function audioAnalyseFree(params) {
  return request({
    url: '/api/user/audioAnalyseFree',
    method: 'get',
    params
  })
}

//音频提取GET/POST/DELETE
export function getAudioAnalyse(params) {
  return request({
    url: '/api/user/audioAnalyse',
    method: 'get',
    params
  })
}
export function postAudioAnalyse(data) {
  return request({
    url: '/api/user/audioAnalyse',
    method: 'post',
    data
  })
}
export function delAudioAnalyse(data) {
  return request({
    url: '/api/user/audioAnalyse',
    method: 'delete',
    data
  })
}
// 抖音账号分析GET/POST/DELETE
export function getAnalyseIp(params) {
  return request({
    url: '/api/coze/analysisIp',
    method: 'get',
    params
  })
}
export function postAnalyseIp(data) {
  return request({
    url: '/api/coze/analysisIp',
    method: 'post',
    data
  })
}
export function delAnalyseIp(data) {
  return request({
    url: '/api/coze/analysisIp',
    method: 'delete',
    data
  })
}

// 抖音视频分析GET/POST/DELETE
export function getAnalysisVideo(params) {
  return request({
    url: '/api/coze/analysisVideo',
    method: 'get',
    params
  })
}
export function postAnalysisVideo(data) {
  return request({
    url: '/api/coze/analysisVideo',
    method: 'post',
    data
  })
}
export function delAnalysisVideo(data) {
  return request({
    url: '/api/coze/analysisVideo',
    method: 'delete',
    data
  })
}

// 人设档案GET/POST/DELETE
export function getProfile(params) {
  return request({
    url: '/api/tikTok/profile',
    method: 'get',
    params
  })
}
export function postProfile(data) {
  return request({
    url: '/api/tikTok/profile',
    method: 'post',
    data
  })
}
export function delProfile(data) {
  return request({
    url: '/api/tikTok/profile',
    method: 'delete',
    data
  })
}

// 产品GET/POST/DELETE
export function getProduct(params) {
  return request({
    url: '/api/tikTok/product',
    method: 'get',
    params
  })
}
export function postProduct(data) {
  return request({
    url: '/api/tikTok/product',
    method: 'post',
    data
  })
}
export function delProduct(data) {
  return request({
    url: '/api/tikTok/product',
    method: 'delete',
    data
  })
}

// 优质文案GET/POST/DELETE
export function getGenerateScript(params) {
  return request({
    url: '/api/coze/generateScript',
    method: 'get',
    params
  })
}
export function postGenerateScript(data) {
  return request({
    url: '/api/coze/generateScript',
    method: 'post',
    data
  })
}
export function delGenerateScript(data) {
  return request({
    url: '/api/coze/generateScript',
    method: 'delete',
    data
  })
}

// 模仿文案GET/POST/DELETE
export function getMimicScript(params) {
  return request({
    url: '/api/coze/mimicScript',
    method: 'get',
    params
  })
}
export function postMimicScript(data) {
  return request({
    url: '/api/coze/mimicScript',
    method: 'post',
    data
  })
}
export function delMimicScript(data) {
  return request({
    url: '/api/coze/mimicScript',
    method: 'delete',
    data
  })
}

// 选题GET/POST/DELETE
export function getTopic(params) {
  return request({
    url: '/api/coze/topic',
    method: 'get',
    params
  })
}
export function postTopic(data) {
  return request({
    url: '/api/coze/topic',
    method: 'post',
    data
  })
}

export function delTopic(data) {
  return request({
    url: '/api/coze/topic',
    method: 'delete',
    data
  })
}

// 消息流
export function getChatIndex(params) {
  return request({
    url: '/api/chat/index',
    method: 'get',
    params,
    isCheck: 2
  })
}
// 对话消息列表
export function getMessageList(params) {
  return request({
    url: '/api/chat/messageList',
    method: 'get',
    params
  })
}
// 历史对话
export function getRecord(params) {
  return request({
    url: '/api/chat/record',
    method: 'get',
    params
  })
}
// 删除历史对话
export function delRecord(params) {
  return request({
    url: '/api/chat/record',
    method: 'delete',
    params
  })
}
// 发送消息
export function postMessage(data) {
  return request({
    url: '/api/chat/sendMessage',
    method: 'post',
    data
  })
}

// 智能体
// 发送消息
export function postBotMessage(data) {
  return request({
    url: '/api/bot/sendMessage',
    method: 'post',
    data
  })
}
// 分类列表
export function typeList(params) {
  return request({
    url: '/api/bot/typeList',
    method: 'get',
    params
  })
}// 智能体列表
export function botList(params) {
  return request({
    url: '/api/bot/botList',
    method: 'get',
    params
  })
}
// 历史对话
export function botRecord(params) {
  return request({
    url: '/api/bot/messageList',
    method: 'get',
    params
  })
}
// 删除历史对话
export function delBotRecord(params) {
  return request({
    url: '/api/bot/record',
    method: 'delete',
    params
  })
}

// 历史对话
export function botMessageList(params) {
  return request({
    url: '/api/bot/record',
    method: 'get',
    params
  })
}
// 异步消息回复内容
export function botMessageDetail(params) {
  return request({
    url: '/api/bot/messageDetail',
    method: 'get',
    params
  })
}

// 素材库GET/POST/DELETE
export function getMaterial(params) {
  return request({
    url: '/api/user/material',
    method: 'get',
    params
  })
}
export function postMaterial(data) {
  return request({
    url: '/api/user/material',
    method: 'post',
    data
  })
}
export function delMaterial(data) {
  return request({
    url: '/api/user/material',
    method: 'delete',
    data
  })
}
// 保存文案素材
export function textMaterial(data) {
  return request({
    url: '/api/user/textMaterial',
    method: 'post',
    data
  })
}
// 招聘
export function postEmploy(data) {
  return request({
    url: '/api/bot/employ',
    method: 'post',
    data
  })
}

// 文案部分的内容
// 灵感库分类
export function promptTypeList(params) {
  return request({
    url: '/api/text/promptTypeList',
    method: 'get',
    params
  })
}
// 灵感库关键词
export function promptKeywords(params) {
  return request({
    url: '/api/text/promptKeywords',
    method: 'get',
    params
  })
}
// 灵感库列表GET/POST/DELETE
export function gprompt(params) {
  return request({
    url: '/api/text/prompt',
    method: 'get',
    params
  })
}
export function pprompt(data) {
  return request({
    url: '/api/text/prompt',
    method: 'post',
    data
  })
}
export function delprompt(data) {
  return request({
    url: '/api/text/prompt',
    method: 'delete',
    data
  })
}

// 发送消息
export function sendMessage(data) {
  return request({
    url: '/api/text/sendMessage',
    method: 'post',
    data
  })
}

// 历史对话
export function chatRecord(params) {
  return request({
    url: '/api/text/chatRecord',
    method: 'get',
    params
  })
}

// 删除历史
export function delchatRecord(data) {
  return request({
    url: '/api/text/chatRecord',
    method: 'delete',
    data
  })
}

// 对话消息列表
export function gmessageList(params) {
  return request({
    url: '/api/text/messageList',
    method: 'get',
    params
  })
}


// 对标账号GET/POST/DELETE
export function gaccount(params) {
  return request({
    url: '/api/text/account',
    method: 'get',
    params
  })
}
export function paccount(data) {
  return request({
    url: '/api/text/account',
    method: 'post',
    data
  })
}
export function delaccount(data) {
  return request({
    url: '/api/text/account',
    method: 'delete',
    data
  })

}
// 对标账号-文案列表
export function gaccountText(params) {
  return request({
    url: '/api/text/accountText',
    method: 'get',
    params
  })
}

// 热点文案GET/POST/DELETE
export function ghotspot(params) {
  return request({
    url: '/api/text/hotspot',
    method: 'get',
    params
  })
}
export function photspot(data) {
  return request({
    url: '/api/text/hotspot',
    method: 'post',
    data
  })
}
export function delhotspot(data) {
  return request({
    url: '/api/text/hotspot',
    method: 'delete',
    data
  })
}


// 链接文案提取GET/POST/DELETE
export function ganalyse(params) {
  return request({
    url: '/api/text/analyse',
    method: 'get',
    params
  })
}
export function panalyse(data) {
  return request({
    url: '/api/text/analyse',
    method: 'post',
    data
  })
}
export function delanalyse(data) {
  return request({
    url: '/api/text/analyse',
    method: 'delete',
    data
  })
}

// 获取素材
export function gmaterial(params) {
  return request({
    url: '/api/user/material',
    method: 'get',
    params
  })
}

// 创建音乐
export function createMusic(data) {
  return request({
    url: '/api/music/createMusic',
    method: 'post',
    data
  })
}
// 我的任务_列表 我的音乐
export function gmyTask(params) {
  return request({
    url: '/api/music/myTask',
    method: 'get',
    params
  })
}

// 音乐_列表
export function gmyMusicWork(params) {
  return request({
    url: '/api/music/myTask',
    method: 'get',
    params
  })
}

// 删除音乐
export function delMusic(data) {
  return request({
    url: '/api/music/myTask',
    method: 'delete',
    data
  })
}


// 热点文案生成记录
export function ghotspotDetailList(params) {
  return request({
    url: '/api/text/hotspotDetailList',
    method: 'get',
    params
  })
}

// 文本翻译
export function postTranslate(data) {
  return request({
    url: '/api/user/translate',
    method: 'post',
    data
  })
}




// 音频任务创建GET/POST/DELETE
export function gVoiceCreate(params) {
  return request({
    url: '/api/voice/create',
    method: 'get',
    params
  })
}

export function postVoiceCreate(data) {
  return request({
    url: '/api/voice/create',
    method: 'post',
    data,
  })
}

export function delVoiceCreate(data) {
  return request({
    url: '/api/voice/create',
    method: 'delete',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/user.js